import { Box, CircularProgress, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Color, FontStyle } from "../../constants";
import { prettyDate } from "../../utils/utils";
import FettiLongInput from "../FettiLongInput";
import { setChatInput } from "../../utils/actionUtils";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MainButton } from "../../utils/buttonUtils";

const styles = {
  expand: {
    width: "30px",
    height: "30px",
    cursor: "pointer",
    color: "#0007",
    transition: "all 0.2s ease-in-out",
    borderRadius: "50%",
    "&:hover": {
      color: "#0009",
      backgroundColor: Color.fettiPurple + "80",
    },
    position: "absolute",
    right: "4px",
    top: "4px",
  },
};

const heightBuffer = 120;
const fullyCollapsedHeight = 39;
const maxCollapsedHeight = 150; // collapsed but allowed to expand a bit
const ChatInput = ({ containerHeight, onSend }) => {
  const dispatch = useDispatch();
  const messageInput = useSelector((state) => state.messages.input);
  const textAreaRef = React.useRef(null);
  const [expandable, setExpandable] = React.useState(false);
  const [expanded, setExpanded] = React.useState(true);
  const [recentExpanded, setRecentExpanded] = React.useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
    setRecentExpanded(true); // for input's height transition
    setTimeout(() => {
      setRecentExpanded(false);
    }, 200);
  };
  useEffect(() => {
    // https://medium.com/@oherterich/creating-a-textarea-with-dynamic-height-using-react-and-typescript-5ed2d78d9848
    if (textAreaRef.current) {
      textAreaRef.current.style.height = "0px";
      let targetHeight = textAreaRef.current.scrollHeight;
      if (targetHeight > fullyCollapsedHeight) {
        setExpandable(true);
      } else {
        setExpandable(false);
      }
      if (containerHeight) {
        targetHeight = Math.min(targetHeight, containerHeight - heightBuffer);
      }
      if (!expanded) {
        targetHeight = Math.min(targetHeight, fullyCollapsedHeight);
      }
      textAreaRef.current.style.height = `${targetHeight + 2}px`;
    }
  }, [textAreaRef, messageInput, expanded]);
  return (
    <Stack
      direction="column"
      sx={{
        px: 2,
        py: 1.5,
        paddingTop: 3,
        backgroundColor: Color.bgLight,
      }}
      spacing={2}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          backgroundColor: Color.bgLight,
          position: "relative",
          //   minHeight: "50px",
        }}>
        <FettiLongInput
          ref={textAreaRef}
          value={messageInput}
          onChange={(v) => setChatInput(dispatch, v.target.value)}
          placeholder="Type a message..."
          maxLength={1000}
          // rows={1}
          style={{
            resize: "none",
            transition: recentExpanded ? "height 0.2s ease-in-out" : "none",
          }}
        />
        {expandable && (
          <Stack
            onClick={toggleExpanded}
            sx={styles.expand}
            alignItems="center"
            justifyContent="center">
            {expanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </Stack>
        )}
      </Stack>
      <Stack direction="row" sx={{ width: "100%" }} justifyContent="flex-end">
        <MainButton
          disableGrow
          disabled={messageInput.length <= 3}
          onClick={() => {
            onSend();
          }}
          sx={{
            py: "7px",
            fontSize: "14px",
            width: "72px",
          }}>
          Send
        </MainButton>
      </Stack>
    </Stack>
  );
};

export default ChatInput;
